module.exports = __webpack_public_path__ + "static/img/pico53.983d0c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico53.png
// module id = 34Wh
// module chunks = 0